module.exports = __webpack_public_path__ + "img/vriendelijk@2x.087a317f.jpg";